<template>
  <div>
    <v-text-field
        :value="value"
        v-bind="schema['x-props']"
    />
  </div>
</template>

<script>
export default {
  name: "VJsfDynamicHttpInput",
  components: {},
  props: {
    value: {type: String, default: ''},
    options: {type: Object, required: true},
    schema: {type: Object, required: true},
    fullSchema: {type: Object, required: true},
    fullKey: {type: String, required: true},
    label: {type: String, default: ''},
    htmlDescription: {type: String, default: ''},
    disabled: {type: Boolean, default: false},
    required: {type: Boolean, default: false},
    rules: {type: Array, required: true},
    on: {type: Object, required: true},
    model: {type: Object, required: true}
  },
  data() {
    return {
      propertyNameToWatch: null,
      propertyValueToWatch: null,
      propertyOldValueToWatch: null,
      url: null,
    }
  },
  computed: {},
  watch: {
    model: {
      handler(newValue, oldValue) {
        if (this.propertyNameToWatch in newValue) {
          this.propertyValueToWatch = newValue[this.propertyNameToWatch];
          this.propertyOldValueToWatch = oldValue[this.propertyNameToWatch];
          if (this.propertyValueToWatch !== this.propertyOldValueToWatch && (!this.propertyValueToWatch || this.propertyValueToWatch.length >= 3)) {
            this.getCode(this.propertyValueToWatch)
          } else {
          }
        } else {
          console.log("Nie ma szukanej wartosci w modelu")
        }
      },
      deep: true
    }
  },
  methods: {
    async getCode(val) {
      if(this.options.httpLib === undefined) console.warn("Brak podanej biblioteki (axios) do żądań HTTP")
      if (val === '') {
        this.$emit('updateCode', {key: this.fullKey, value: null})
      } else {
        await this.options.httpLib.get(this.url + val)
            .then((response) => {
              this.$emit('updateCode', {key: this.fullKey, value: response.data[this.schema['response-key']]})
            })
      }
    }
  },
  mounted() {
    this.propertyNameToWatch = this.schema["watch-property"];
    this.url = this.options.context[this.fullKey].generatorUrl
  }
}
</script>

<style scoped lang="css">

</style>
